<template>
  <div class="pokerpower-app-section">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://pokerpower.com/" target="_blank">
            <h4 class="client">Poker Power</h4>
          </a>
          <h1 class="title">
            {{ $t("pokerPower.title") }}
          </h1>
          <p class="date">
            {{ $t("pokerPower.duration.title") }}
            {{ $t("pokerPower.duration.date") }}
          </p>
          <p class="role">
            {{ $t("pokerPower.position.title") }}
            {{ $t("pokerPower.position.role") }}
          </p>
          <p class="description">
            {{ $t("pokerPower.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              APP
              <ul class="menu-list">
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.app.bullet1") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.app.bullet2") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.app.bullet3") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.app.bullet4") }}
                </li>
              </ul>
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              API
              <ul class="menu-list">
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.api.bullet1") }}
                </li>
                <li class="bullet wow animate__animated animate__backInLeft">
                  {{ $t("pokerPower.api.bullet2") }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <img
            class="app-image"
            src="@/assets/pp-mini-games-lobby.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PokerPower",
  components: {},
};
</script>
<style lang="scss" scoped>
div.pokerpower-app-section {
  background-color: rgb(100 20 185);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 3rem;

  div.columns {
    height: 100%;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: bold;
      color: gray;
    }

    h1.title {
      font-family: "Raleway";
      color: #fff;
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #e5e5e5;
      margin-top: 1.5rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #cccccc;
      font-size: 1.2rem;
    }

    ul {
      font-family: "Raleway";
      list-style: inside;
      color: #cccccc;

      li {
        text-align: left;
        margin: 0.5rem 0;
      }
    }
  }

  div.multimedia-container {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    img.app-image {
      border-radius: 60px;
      box-shadow: 0 2rem 5rem rgba(0, 0, 0, 0.22);
      height: auto;
      max-width: 80%;

      @media (min-width: 600px) {
        max-height: 68vh;
        max-width: 28rem;
      }
    }

    div.store-icons {
      background: transparent;
      img {
        height: 3rem;
        margin: 0.6rem;
      }
    }

    @media (max-width: 700px) {
      img.app-image {
        max-width: 80%;
      }
    }
  }
}
</style>
